import IconFacebook from '@fortuneo/ui-icons/general/IconFacebook'
import IconLinkedin from '@fortuneo/ui-icons/general/IconLinkedin'
import IconX from '@fortuneo/ui-icons/general/IconX'
import IconYoutube from '@fortuneo/ui-icons/general/IconYoutube'

export const socialButtons = [
  {
    icon: IconFacebook,
    href: 'https://www.facebook.com/fortuneo.banque',
  },
  {
    icon: IconX,
    href: 'https://twitter.com/fortuneo',
  },
  {
    icon: IconYoutube,
    href: 'https://www.youtube.com/user/fortuneodemo',
  },
  {
    icon: IconLinkedin,
    href: 'https://fr.linkedin.com/company/fortuneo',
  },
]

export type Domain = 'site' | 'private' | 'market'

export const domains = {
  site: {
    staging: 'https://preprod-www.fortuneo.fr',
    production: 'https://www.fortuneo.fr',
  },
  private: {
    staging: 'https://preprod-mabanque.fortuneo.fr',
    production: 'https://mabanque.fortuneo.fr',
  },
  market: {
    staging: 'https://preprod-bourse.fortuneo.fr',
    production: 'https://bourse.fortuneo.fr',
  },
}

export type PrivateDomainPath = 'contact' | 'login'

export const privateDomainPaths = {
  contact: '/fr/mail7.jsp',
  login: '/fr/identification.jsp',
}

export const siteUrl = 'https://www.fortuneo.fr'

export const SUBSCRIPTION_ENTRY = {
  COMPTE_BANCAIRE: '/compte-bancaire/souscrire',
  LIVRET: '/epargne/livret/ouvrir-un-livret',
  LIVRET_A: '/epargne/livret-a/ouvrir-un-livret',
  LIVRET_PLUS: '/epargne/livret-plus/ouvrir-un-livret',
  LIVRET_DD: '/epargne/livret-developpement-durable/ouvrir-un-livret',
  LIVRET_PLUS_ENFANT: '/epargne/livret-plus-enfant/ouvrir-un-livret',
  ASSURANCE_VIE: '/assurance-vie/souscrire-une-assurance',
  BOURSE: '/compte-titres/souscrire-en-ligne',
  CREDIT_IMMOBILIER: '/credit-immobilier/demander-un-pret',
  PER: '/plan-epargne-retraite/souscrire',
}

export const faqRootPathname = '/faq'
export const blogRootPathname = '/blog'
export const blogAuthorRootPathname = `${blogRootPathname}/auteur`

export type BreadcrumbItem = {
  name?: string
  href?: string
}

export const blogHomeBreadcrumb: BreadcrumbItem = {
  name: 'Blog',
  href: blogRootPathname,
}

export const faqHomeBreadcrumb: BreadcrumbItem = {
  name: 'FAQ',
  href: faqRootPathname,
}

export const faqSearchBreadcrumb: BreadcrumbItem = {
  name: 'Recherche',
  href: `${faqRootPathname}/recherche`,
}

export const homeBreadcrumb: BreadcrumbItem = {
  name: 'Accueil',
  href: '/',
}
